package com.eladfinish.bible.contest.features.copyOptions.model

import androidx.compose.runtime.Immutable

@Immutable
data class CopyOptionsConfig(
    val shouldShowSearchedExpressionOption: Boolean,
    val shouldShowRemoveDuplicatesOption: Boolean,
    val shouldShowSortResultOption: Boolean,
    val shouldShowIncludeBookAndChapterOption: Boolean,
    val shouldShowHighlightsSection: Boolean,
    val shouldShowAdvancedOptionsSection: Boolean,
)
